import { render, staticRenderFns } from "./document-template-card.vue?vue&type=template&id=441ed5ff&"
import script from "./document-template-card.vue?vue&type=script&lang=js&"
export * from "./document-template-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports